module.exports = __webpack_public_path__ + "img/other_1.7335790d.png";